//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'Relationships',
  components: {
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
  },
  props: {
    mediaType: {
      type: String,
      required: true,
    },
    relatedElements: {
      type: Array,
      required: true,
    },
  },
  methods: {
    renderMediaTypeLabel(mediaType) {
      switch (true) {
        case isProductType('gif', mediaType):
          return `${this.$t('product.image')} + GIF`;

        case isProductType('video', mediaType):
          return this.$t('product.video');

        default:
          return mediaType;
      }
    },
  },
};
